import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CookieService } from 'ngx-cookie-service';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
let cookie:any = CookieService;
/* console.log(cookie.get('token')) */
/* if(!document.cookie)
	initStorage(); */
initStorage();
function initStorage() {

  var gs_local_storage = (function () {
    var store = {};
    return {
      getItem: function (key: string) {
        return store[key];
      },
      setItem: function (key: string, value: string) {
        store[key] = value;
      },
      clear: function () {
        store = {};
      },
      removeItem: function (key: string) {
        delete store[key];
      }
    };
  })();

  /* var gs_session_storage = (function () {
    var store = {};
    return {
      getItem: function (key: string) {
        return store[key];
      },
      setItem: function (key: string, value: string) {
        store[key] = value;
      },
      clear: function () {
        store = {};
      },
      removeItem: function (key: string) {
        delete store[key];
      }
    };
  })(); */

  /* Object.defineProperty(window, 'sessionStorage', { value: gs_session_storage }); */
  Object.defineProperty(window, 'localStorage', { value: gs_local_storage });
}




platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
